import * as actionTypes from "./actionTypes";

export const initBooking = () => ({ type: actionTypes.BOOKING_INIT });

export const bookingSuccess = (data) => {
  return { type: actionTypes.BOOKING_SUCCESS, data };
};

export const bookingFailed = (data) => {
  return { type: actionTypes.BOOKING_FAILED, data };
};
